import { createSlice } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";
import type { IncomeDetailRes } from "core/http/service/salary/resTypes";

/** Chi tiết tra cứu thu nhập (API income) */
export type SalaryDetail = IncomeDetailRes;

interface InitialState {
  data: SalaryDetail | null;
  status: ReduxStateType;
  isShow: boolean;
}

const initialState: InitialState = {
  data: null,
  status: ReduxStateType.INIT,
  isShow: false,
};

const getSalaryDetailSlice = createSlice({
  name: "salary/getSalaryDetail",
  initialState,
  reducers: {
    getSalaryDetailStart: (state, _action) => {
      state.status = ReduxStateType.LOADING;
    },
    getSalaryDetailSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload?.data ?? null;
    },
    getSalaryDetailFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = null;
    },
    resetSalaryDetail: () => initialState,
    updateHideSalaryDetail: (state, action) => {
      state.isShow = action.payload;
    },
  },
});

export const {
  getSalaryDetailStart,
  getSalaryDetailSuccess,
  getSalaryDetailFailed,
  resetSalaryDetail,
  updateHideSalaryDetail,
} = getSalaryDetailSlice.actions;

export default getSalaryDetailSlice.reducer;
